import { Toast } from "bootstrap";

import { disposeBootstrapComponent } from "./bootstrap";

let toastHidePatched = false;

// Bootstrap 5.3.8's Toast.hide() derefs a nulled _element when a queued autohide timer runs after dispose(); make it a no-op.
function patchToastHideNullSafe(): void {
  if (toastHidePatched) return;
  toastHidePatched = true;
  const proto = Toast.prototype as unknown as {
    hide: (this: { _element: HTMLElement | null }) => void;
  };
  const originalHide = proto.hide;
  proto.hide = function (this: { _element: HTMLElement | null }) {
    if (!this._element) return;
    originalHide.call(this);
  };
}

export enum FlashKindEnum {
  SUCCESS = "success",
  ALERT = "alert",
  INFO = "info",
}

export interface FlashOptions {
  description?: string;
}

const uniqueId = (length = 16): number => {
  return parseInt(
    Math.ceil(Math.random() * Date.now())
      .toPrecision(length)
      .toString()
      .replace(".", "")
  );
};

const ICON_MAP: Record<FlashKindEnum, string> = {
  [FlashKindEnum.SUCCESS]: "check-circle",
  [FlashKindEnum.ALERT]: "exclamation-circle",
  [FlashKindEnum.INFO]: "info-circle",
};

export const flash = (
  kind: `${FlashKindEnum}`,
  message: string,
  options?: FlashOptions
): void => {
  patchToastHideNullSafe();
  const id = uniqueId();
  const iconName = ICON_MAP[kind as FlashKindEnum] ?? "info-circle";

  let descriptionHtml = "";
  if (options?.description) {
    descriptionHtml = `<p class="toast__description">${options.description}</p>`;
  }

  const closeHtml = `<button type="button" class="toast__close" data-bs-dismiss="toast" aria-label="Close"><i class="bi bi-x-lg" aria-hidden="true"></i></button>`;

  let bodyHtml = "";
  if (descriptionHtml) {
    bodyHtml = `<div class="toast__body">${descriptionHtml}</div>`;
  }

  const result = `<div id="toast-${id}" class="toast toast--fixed toast--${kind}"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="toast__header">
        <i class="bi bi-${iconName} toast__icon" aria-hidden="true"></i>
        <span class="toast__title">${message}</span>
      </div>
      ${bodyHtml}
      ${closeHtml}
    </div>`;

  const body = document.querySelector("body");
  if (body) {
    body.insertAdjacentHTML("beforeend", result);
    const toastElement = document.querySelector<HTMLElement>(`#toast-${id}`);
    if (toastElement) {
      const toast = new Toast(toastElement, {
        autohide: true,
        delay: 3000,
      });
      toastElement.addEventListener("hidden.bs.toast", () => {
        // Flush any sibling pending transition before dispose nulls _element (double-hide race).
        disposeBootstrapComponent(toastElement, toast);
        toastElement.remove();
      });
      toast.show();
    }
  }
};
